
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eMuR8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6d288bc5ab2750bd$export$9fcadd4d00583a89 = (callback)=>{
    const callbackRef = (0, $cozmU.useRef)(callback);
    callbackRef.current = callback;
    return (0, $cozmU.useCallback)((...args)=>callbackRef.current(...args), []);
};
module.exports["useStaticCallback"] = $6d288bc5ab2750bd$export$9fcadd4d00583a89;

});

parcelRegister("a86m3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1hQ0e = parcelRequire("1hQ0e");


var $eMuR8 = parcelRequire("eMuR8");

















var $lfoFx = parcelRequire("lfoFx");













const $ffac732fa0f5deca$var$formInputBaseStyles = null; /**
                                   * By default, the visual pdf form elements are rendered by pdfium server side. Therefore we only
                                   * show visibility of the html input if the user interacts with it. This allows us to show visually
                                   * accurate PDF form elements while still allowing the user to interact with the input.
                                   */ 
const $ffac732fa0f5deca$var$invisibleInputStyles = null;
const $ffac732fa0f5deca$var$textInputStyles = null;
const $ffac732fa0f5deca$var$foreignObjectProps = {
    xmlns: 'http://www.w3.org/1999/xhtml'
};
const $ffac732fa0f5deca$var$TextInput = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { as: Component, value: value, style: style } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0WKd3GnReW _26BoRwYKtr _034jHtYbGa _2HIj7GYbGa",
            "_1mT5xdWVPG _0jFU0VN91d _24h04i2Njc _39xV02N91d",
            "_4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _1UtDYzjOvk _1F3nKmIZbP _3crodHIZbP _1iy5hxt28M _10n1R552mJ"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== Component || $[2] !== style || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...$ffac732fa0f5deca$var$foreignObjectProps,
            style: style,
            onKeyUp: $ffac732fa0f5deca$var$_temp,
            value: value,
            type: "text",
            readOnly: true,
            className: t1
        });
        $[1] = Component;
        $[2] = style;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ as: Component, value: value, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ...$ffac732fa0f5deca$var$foreignObjectProps,
        style: style,
        onKeyUp: (e)=>{
            // stop propagation of the arrow key events because they can be used to navigate viewports
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') e.stopPropagation();
        },
        value: value,
        type: "text",
        readOnly: true,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0WKd3GnReW _26BoRwYKtr _034jHtYbGa _2HIj7GYbGa",
            "_1mT5xdWVPG _0jFU0VN91d _24h04i2Njc _39xV02N91d",
            "_4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _1UtDYzjOvk _1F3nKmIZbP _3crodHIZbP _1iy5hxt28M _10n1R552mJ"
        ])
    }); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $ffac732fa0f5deca$export$6678b274895114f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { field: field, dataTestId: dataTestId } = t0;
    const t1 = `${field.f}px`;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            "fontSize": t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const style = t2;
    const t3 = -field.y;
    const t4 = field.multiline ? "textarea" : "input";
    let t5;
    if ($[2] !== field.text || $[3] !== style || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ffac732fa0f5deca$var$TextInput, {
            style: style,
            as: t4,
            value: field.text
        });
        $[2] = field.text;
        $[3] = style;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== dataTestId || $[7] !== field.h || $[8] !== field.w || $[9] !== field.x || $[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
            x: field.x,
            y: t3,
            width: field.w,
            height: field.h,
            "data-testid": dataTestId
        }, t5);
        $[6] = dataTestId;
        $[7] = field.h;
        $[8] = field.w;
        $[9] = field.x;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ field: field, dataTestId: dataTestId })=>{
    const style = {
        ['fontSize']: `${field.f}px`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
        x: field.x,
        y: -field.y,
        width: field.w,
        height: field.h,
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ffac732fa0f5deca$var$TextInput, {
        style: style,
        as: field.multiline ? 'textarea' : 'input',
        value: field.text
    }));
};
const $ffac732fa0f5deca$var$comboBoxStyles = null;
const $ffac732fa0f5deca$var$comboBoxInputStyles = null; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $ffac732fa0f5deca$export$6242fe373f3bbded = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { field: field, dataTestId: dataTestId } = t0;
    const t1 = field.x;
    const t2 = -field.y;
    const t3 = field.w;
    const t4 = field.h;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_3iDTPbgBM8 _2iEGP2MUDv _0hPCNLDIqT _37wbyuI7V3 _1mT5xdWVPG _0jFU0VN91d _39xV02N91d"
        ]);
        $[0] = t5;
    } else t5 = $[0];
    const t6 = `${field.f}px`;
    let t7;
    if ($[1] !== t6) {
        t7 = {
            "fontSize": t6
        };
        $[1] = t6;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = field.text;
    let t9;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            "_30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0WKd3GnReW _26BoRwYKtr _034jHtYbGa _2HIj7GYbGa",
            "_39xV02N91d",
            "_4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _1UtDYzjOvk _1F3nKmIZbP _3crodHIZbP _1iy5hxt28M _10n1R552mJ"
        ]);
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== field.text || $[5] !== t7) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...$ffac732fa0f5deca$var$foreignObjectProps,
            className: t5
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            style: t7,
            type: "text",
            value: t8,
            onKeyUp: $ffac732fa0f5deca$var$_temp2,
            readOnly: true,
            className: t9
        }));
        $[4] = field.text;
        $[5] = t7;
        $[6] = t10;
    } else t10 = $[6];
    let t11;
    if ($[7] !== dataTestId || $[8] !== field.h || $[9] !== field.w || $[10] !== field.x || $[11] !== t10 || $[12] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
            x: t1,
            y: t2,
            width: t3,
            height: t4,
            "data-testid": dataTestId
        }, t10);
        $[7] = dataTestId;
        $[8] = field.h;
        $[9] = field.w;
        $[10] = field.x;
        $[11] = t10;
        $[12] = t2;
        $[13] = t11;
    } else t11 = $[13];
    return t11;
} : ({ field: field, dataTestId: dataTestId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
        x: field.x,
        y: -field.y,
        width: field.w,
        height: field.h,
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...$ffac732fa0f5deca$var$foreignObjectProps,
        className: (0, $hekY6.default)([
            "_3iDTPbgBM8 _2iEGP2MUDv _0hPCNLDIqT _37wbyuI7V3 _1mT5xdWVPG _0jFU0VN91d _39xV02N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        style: {
            ['fontSize']: `${field.f}px`
        },
        type: "text",
        value: field.text,
        onKeyUp: (e)=>{
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') e.stopPropagation();
        },
        readOnly: true,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0WKd3GnReW _26BoRwYKtr _034jHtYbGa _2HIj7GYbGa",
            "_39xV02N91d",
            "_4bt5LAnQyn _2WAcuGnQyn _0KLXrujOvk _1UtDYzjOvk _1F3nKmIZbP _3crodHIZbP _1iy5hxt28M _10n1R552mJ"
        ])
    })));
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $ffac732fa0f5deca$export$e3ca8059b2de989 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { annotations: annotations } = t0;
    let t1;
    if ($[0] !== annotations.text_form_fields) {
        t1 = annotations.text_form_fields.map($ffac732fa0f5deca$var$_temp3);
        $[0] = annotations.text_form_fields;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== annotations.combobox_form_fields) {
        t2 = annotations.combobox_form_fields.map($ffac732fa0f5deca$var$_temp4);
        $[2] = annotations.combobox_form_fields;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ annotations: annotations })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, annotations.text_form_fields.map((field, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ffac732fa0f5deca$export$6678b274895114f9, {
            field: field,
            dataTestId: `text-form-field-${i}`,
            key: i
        });
    }), annotations.combobox_form_fields.map((field_0, i_0)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ffac732fa0f5deca$export$6242fe373f3bbded, {
            field: field_0,
            dataTestId: `combobox-form-field-${i_0}`,
            key: i_0
        });
    }));
};
function $ffac732fa0f5deca$var$_temp(e) {
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") e.stopPropagation();
}
function $ffac732fa0f5deca$var$_temp2(e) {
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") e.stopPropagation();
}
function $ffac732fa0f5deca$var$_temp3(field, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ffac732fa0f5deca$export$6678b274895114f9, {
        field: field,
        dataTestId: `text-form-field-${i}`,
        key: i
    });
}
function $ffac732fa0f5deca$var$_temp4(field_0, i_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ffac732fa0f5deca$export$6242fe373f3bbded, {
        field: field_0,
        dataTestId: `combobox-form-field-${i_0}`,
        key: i_0
    });
}












var $l8Rhq = parcelRequire("l8Rhq");

const $61d1ee26d33a3b6f$var$foreignObjectProps = {
    xmlns: 'http://www.w3.org/1999/xhtml'
};
const $61d1ee26d33a3b6f$var$anchorStyles = {
    display: 'block',
    width: '100%',
    height: '100%'
};
const $61d1ee26d33a3b6f$var$DocumentLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { link: link, dataTestId: dataTestId, appendUpTo: appendUpTo } = t0;
    const t1 = -link.y;
    let t2;
    if ($[0] !== appendUpTo || $[1] !== link.dest || $[2] !== link.p_num || $[3] !== link.type) {
        t2 = link.type === "uri" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
            ...$61d1ee26d33a3b6f$var$foreignObjectProps,
            href: link.dest,
            target: "_blank",
            rel: "noopener noreferrer",
            style: $61d1ee26d33a3b6f$var$anchorStyles
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
            ...$61d1ee26d33a3b6f$var$foreignObjectProps,
            href: `#page-${link.p_num + 1}`,
            style: $61d1ee26d33a3b6f$var$anchorStyles,
            onClick: appendUpTo ? ()=>appendUpTo(link.p_num + 1) : undefined
        });
        $[0] = appendUpTo;
        $[1] = link.dest;
        $[2] = link.p_num;
        $[3] = link.type;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== dataTestId || $[6] !== link.h || $[7] !== link.w || $[8] !== link.x || $[9] !== t1 || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
            x: link.x,
            y: t1,
            width: link.w,
            height: link.h,
            "data-testid": dataTestId
        }, t2);
        $[5] = dataTestId;
        $[6] = link.h;
        $[7] = link.w;
        $[8] = link.x;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ link: link, dataTestId: dataTestId, appendUpTo: appendUpTo })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
        x: link.x,
        y: -link.y,
        width: link.w,
        height: link.h,
        "data-testid": dataTestId
    }, link.type === 'uri' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
        ...$61d1ee26d33a3b6f$var$foreignObjectProps,
        href: link.dest,
        target: "_blank",
        rel: "noopener noreferrer",
        style: $61d1ee26d33a3b6f$var$anchorStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
        ...$61d1ee26d33a3b6f$var$foreignObjectProps,
        href: `#page-${link.p_num + 1}`,
        style: $61d1ee26d33a3b6f$var$anchorStyles,
        onClick: appendUpTo ? ()=>appendUpTo(link.p_num + 1) : undefined
    }));
};
const $61d1ee26d33a3b6f$export$3fad1bab42e464d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { links: links, appendUpTo: appendUpTo } = t0;
    let t1;
    if ($[0] !== appendUpTo || $[1] !== links) {
        let t2;
        if ($[3] !== appendUpTo) {
            t2 = (link, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61d1ee26d33a3b6f$var$DocumentLink, {
                    link: link,
                    dataTestId: `document-link-${i}`,
                    appendUpTo: appendUpTo,
                    key: i
                });
            $[3] = appendUpTo;
            $[4] = t2;
        } else t2 = $[4];
        t1 = links.map(t2);
        $[0] = appendUpTo;
        $[1] = links;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ links: links, appendUpTo: appendUpTo })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, links.map((link, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61d1ee26d33a3b6f$var$DocumentLink, {
            link: link,
            dataTestId: `document-link-${i}`,
            appendUpTo: appendUpTo,
            key: i
        })));
};






var $glkQ6 = parcelRequire("glkQ6");

const $edfdd7b66687d308$export$6492b66915332185 = ()=>{
    const doc = (0, $1hQ0e.getDocument)();
    if (!doc) return;
    const root = doc.getElementById((0, $glkQ6.DOCUMENT_SCROLL_ROOT_ID));
    if (root) return root;
    return doc;
};














const $d3d42c4a5207b051$export$a7395f9832c00176 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (options, onVisible)=>{
    const $ = (0, $bDgLe.c)(7);
    const staticOnVisible = (0, $eMuR8.useStaticCallback)(onVisible);
    const observerRef = (0, $cozmU.useRef)(null);
    const timeoutRef = (0, $cozmU.useRef)(null);
    const isVisibleRef = (0, $cozmU.useRef)(false);
    const currentNodeRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] !== options || $[1] !== staticOnVisible) {
        t0 = (node)=>{
            currentNodeRef.current = node;
            if (observerRef.current) observerRef.current.disconnect();
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            if (node) {
                observerRef.current = new IntersectionObserver((t1)=>{
                    const [entry] = t1;
                    if (entry.isIntersecting && !isVisibleRef.current) {
                        isVisibleRef.current = true;
                        timeoutRef.current = setTimeout(()=>{
                            if (isVisibleRef.current) {
                                staticOnVisible();
                                timeoutRef.current = null;
                            }
                        }, 100);
                    }
                    if (!entry.isIntersecting && isVisibleRef.current) isVisibleRef.current = false;
                    if (!entry.isIntersecting && isVisibleRef.current && timeoutRef.current) {
                        isVisibleRef.current = false;
                        clearTimeout(timeoutRef.current);
                        timeoutRef.current = null;
                    }
                }, options);
                observerRef.current.observe(node);
            }
        };
        $[0] = options;
        $[1] = staticOnVisible;
        $[2] = t0;
    } else t0 = $[2];
    const observedRef = (0, $eMuR8.useStaticCallback)(t0);
    let t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>()=>{
                if (observerRef.current) observerRef.current.disconnect();
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            };
        t2 = [];
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== observedRef) {
        t3 = {
            observedRef: observedRef,
            isVisibleRef: isVisibleRef
        };
        $[5] = observedRef;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (options, onVisible)=>{
    const staticOnVisible = (0, $eMuR8.useStaticCallback)(onVisible);
    const observerRef = (0, $cozmU.useRef)(null);
    const timeoutRef = (0, $cozmU.useRef)(null);
    const isVisibleRef = (0, $cozmU.useRef)(false);
    const currentNodeRef = (0, $cozmU.useRef)(null);
    const observedRef = (0, $eMuR8.useStaticCallback)((node)=>{
        currentNodeRef.current = node;
        if (observerRef.current) observerRef.current.disconnect();
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (node) {
            observerRef.current = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting && !isVisibleRef.current) {
                    isVisibleRef.current = true;
                    timeoutRef.current = setTimeout(()=>{
                        if (isVisibleRef.current) {
                            staticOnVisible();
                            timeoutRef.current = null;
                        }
                    }, 100);
                }
                if (!entry.isIntersecting && isVisibleRef.current) isVisibleRef.current = false;
                if (!entry.isIntersecting && isVisibleRef.current && timeoutRef.current) {
                    isVisibleRef.current = false;
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            }, options);
            observerRef.current.observe(node);
        }
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    return {
        observedRef: observedRef,
        isVisibleRef: isVisibleRef
    };
};


const $54be4644f67ec168$var$Span = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { span: span, font: font } = t0;
    const width = span.l;
    const height = span.h;
    if (width <= 0) return null;
    const t1 = `-${span.y}`;
    const t2 = `${font.name}`;
    const t3 = `${font.size === 1 ? height : font.size}px`;
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = {
            "fontFamily": t2,
            "fontSize": t3
        };
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== height || $[4] !== span.text || $[5] !== span.x || $[6] !== t1 || $[7] !== t4 || $[8] !== width) {
        t5 = /*#__PURE__*/ $cozmU.createElement("tspan", {
            lengthAdjust: "spacingAndGlyphs",
            x: span.x,
            y: t1,
            height: height,
            textLength: width,
            style: t4
        }, span.text);
        $[3] = height;
        $[4] = span.text;
        $[5] = span.x;
        $[6] = t1;
        $[7] = t4;
        $[8] = width;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ span: span, font: font })=>{
    const width = span.l;
    const height = span.h;
    if (width <= 0) return null;
    return /*#__PURE__*/ $cozmU.createElement("tspan", {
        lengthAdjust: "spacingAndGlyphs",
        x: span.x,
        y: `-${span.y}`,
        height: height,
        textLength: width,
        style: {
            ['fontFamily']: `${font.name}`,
            ['fontSize']: `${font.size === 1 ? height : font.size}px`
        }
    }, span.text);
};
const $54be4644f67ec168$var$textStyles = null;
const $54be4644f67ec168$var$Line = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {
            spans: [],
            rotation: 0,
            fonts: []
        } : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { spans: spans, rotation: rotation, fonts: fonts, dataTestId: dataTestId } = t1;
    const t2 = `${spans[0].x} -${spans[0].y}`;
    const t3 = `rotate(${rotation}rad)`;
    let t4;
    if ($[2] !== t3) {
        t4 = {
            transform: t3
        };
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_1ANEUSZYee"
        ]);
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== fonts || $[6] !== spans) {
        let t7;
        if ($[8] !== fonts) {
            t7 = (span, i)=>/*#__PURE__*/ $cozmU.createElement($54be4644f67ec168$var$Span, {
                    span: span,
                    font: fonts[span.fi],
                    key: i
                });
            $[8] = fonts;
            $[9] = t7;
        } else t7 = $[9];
        t6 = spans.map(t7);
        $[5] = fonts;
        $[6] = spans;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[10] !== dataTestId || $[11] !== t2 || $[12] !== t4 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("text", {
            opacity: "0.5",
            "transform-origin": t2,
            style: t4,
            "data-testid": dataTestId,
            className: t5
        }, t6);
        $[10] = dataTestId;
        $[11] = t2;
        $[12] = t4;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ({ spans: spans, rotation: rotation, fonts: fonts, dataTestId: dataTestId } = {
    spans: [],
    rotation: 0,
    fonts: []
})=>/*#__PURE__*/ $cozmU.createElement("text", {
        opacity: "0.5",
        "transform-origin": `${spans[0].x} -${spans[0].y}`,
        style: {
            transform: `rotate(${rotation}rad)`
        },
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_1ANEUSZYee"
        ])
    }, spans.map((span, i)=>/*#__PURE__*/ $cozmU.createElement($54be4644f67ec168$var$Span, {
            span: span,
            font: fonts[span.fi],
            key: i
        })));
const $54be4644f67ec168$var$pageSvgStyles = null;
const $54be4644f67ec168$var$pageImageStyles = null;
const $54be4644f67ec168$var$pixelatedImageRendering = null;
const $54be4644f67ec168$var$pageSpinnerStyles = null;
const $54be4644f67ec168$var$pageWrapperStyles = null;
const $54be4644f67ec168$var$a4Dimensions = {
    height: 595,
    width: 842
};
const $54be4644f67ec168$var$PageView = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(26);
    const { dimensions: dimensions, imageSrc: imageSrc, content: content, fonts: fonts, pageIndex: pageIndex, zoom: zoom, onImageLoad: onImageLoad, appendUpTo: appendUpTo } = t0;
    let style;
    if ($[0] !== dimensions || $[1] !== imageSrc) {
        style = {};
        if (dimensions) {
            style.width = `calc(var(--document-viewer-zoom) * ${dimensions.width}px)`;
            style.height = `calc(var(--document-viewer-zoom) * ${dimensions.height}px)`;
        } else if (imageSrc) {
            style.width = "initial";
            style.height = "initial";
        } else {
            style.width = `calc(var(--document-viewer-zoom) * ${$54be4644f67ec168$var$a4Dimensions.width}px)`;
            style.height = `calc(var(--document-viewer-zoom) * ${$54be4644f67ec168$var$a4Dimensions.height}px)`;
        }
        $[0] = dimensions;
        $[1] = imageSrc;
        $[2] = style;
    } else style = $[2];
    const t1 = `page-${pageIndex}`;
    const t2 = `page-${pageIndex + 1}`;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_1mT5xdRAKS _0KLXrut28M _2XsHFMIZbP _0adFHsIZbP"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== imageSrc) {
        t4 = !imageSrc && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_0jFU0VN91d _39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "large"
        }));
        $[4] = imageSrc;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== imageSrc || $[7] !== onImageLoad || $[8] !== pageIndex || $[9] !== style || $[10] !== zoom) {
        t5 = imageSrc && /*#__PURE__*/ $cozmU.createElement("img", {
            style: style,
            "data-testid": `page-${pageIndex}-image`,
            "data-zoom": zoom,
            src: imageSrc,
            alt: "",
            onLoad: onImageLoad,
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _20VacPYbGa",
                "_3IONCn9XGU"
            ])
        });
        $[6] = imageSrc;
        $[7] = onImageLoad;
        $[8] = pageIndex;
        $[9] = style;
        $[10] = zoom;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== appendUpTo || $[13] !== content || $[14] !== fonts || $[15] !== pageIndex || $[16] !== style) {
        t6 = content && /*#__PURE__*/ $cozmU.createElement("svg", {
            "data-testid": `page-${pageIndex}-text-layer`,
            style: style,
            viewBox: `0 -${content.height} ${content.width} ${content.height}`,
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _20VacPJxkL _1rdFvhjOvk"
            ])
        }, content.lines.map((line, i)=>/*#__PURE__*/ $cozmU.createElement($54be4644f67ec168$var$Line, {
                dataTestId: `page-${pageIndex}-line-${i}`,
                spans: line.spans,
                rotation: line.r,
                fonts: fonts,
                key: i
            })), content.annotations && /*#__PURE__*/ $cozmU.createElement((0, $ffac732fa0f5deca$export$e3ca8059b2de989), {
            annotations: content.annotations
        }), content.links && /*#__PURE__*/ $cozmU.createElement((0, $61d1ee26d33a3b6f$export$3fad1bab42e464d9), {
            links: content.links,
            appendUpTo: appendUpTo
        }));
        $[12] = appendUpTo;
        $[13] = content;
        $[14] = fonts;
        $[15] = pageIndex;
        $[16] = style;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== ref || $[19] !== style || $[20] !== t1 || $[21] !== t2 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            style: style,
            "data-testid": t1,
            id: t2,
            className: t3
        }, t4, t5, t6);
        $[18] = ref;
        $[19] = style;
        $[20] = t1;
        $[21] = t2;
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    return t7;
} : ({ dimensions: dimensions, imageSrc: imageSrc, content: content, fonts: fonts, pageIndex: pageIndex, zoom: zoom, onImageLoad: onImageLoad, appendUpTo: appendUpTo }, ref)=>{
    const style = {};
    if (dimensions) {
        // contents endpoint has loaded so dimensions are available
        style.width = `calc(var(--document-viewer-zoom) * ${dimensions.width}px)`;
        style.height = `calc(var(--document-viewer-zoom) * ${dimensions.height}px)`;
    } else if (imageSrc) {
        // contents endpoint has not loaded dimensions but image is loaded so we can use the image dimensions
        style.width = 'initial';
        style.height = 'initial';
    } else {
        // contents endpoint has not loaded dimensions and image is not loaded so we can use the a4 dimensions
        style.width = `calc(var(--document-viewer-zoom) * ${$54be4644f67ec168$var$a4Dimensions.width}px)`;
        style.height = `calc(var(--document-viewer-zoom) * ${$54be4644f67ec168$var$a4Dimensions.height}px)`;
    }
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": `page-${pageIndex}`,
        id: `page-${pageIndex + 1}`,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _0KLXrut28M _2XsHFMIZbP _0adFHsIZbP"
        ])
    }, !imageSrc && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VN91d _39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large"
    })), imageSrc && /*#__PURE__*/ $cozmU.createElement("img", {
        style: style,
        "data-testid": `page-${pageIndex}-image`,
        "data-zoom": zoom,
        src: imageSrc,
        alt: "",
        onLoad: onImageLoad,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _20VacPYbGa",
            "_3IONCn9XGU"
        ])
    }), content && /*#__PURE__*/ $cozmU.createElement("svg", {
        "data-testid": `page-${pageIndex}-text-layer`,
        style: style,
        viewBox: `0 -${content.height} ${content.width} ${content.height}`,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _20VacPJxkL _1rdFvhjOvk"
        ])
    }, content.lines.map((line, i)=>/*#__PURE__*/ $cozmU.createElement($54be4644f67ec168$var$Line, {
            dataTestId: `page-${pageIndex}-line-${i}`,
            spans: line.spans,
            rotation: line.r,
            fonts: fonts,
            key: i
        })), content.annotations && /*#__PURE__*/ $cozmU.createElement((0, $ffac732fa0f5deca$export$e3ca8059b2de989), {
        annotations: content.annotations
    }), content.links && /*#__PURE__*/ $cozmU.createElement((0, $61d1ee26d33a3b6f$export$3fad1bab42e464d9), {
        links: content.links,
        appendUpTo: appendUpTo
    })));
});
const $54be4644f67ec168$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { getPageSrc: getPageSrc, content: content, fonts: fonts, pageIndex: pageIndex, zoom: zoom, defaultDimensions: defaultDimensions, onVisible: onVisible, onLoad: onLoad, appendUpTo: appendUpTo } = t0;
    const [imageSrc, setImageSrc] = (0, $cozmU.useState)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            root: (0, $edfdd7b66687d308$export$6492b66915332185)(),
            rootMargin: "300%",
            threshold: 0.1
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== getPageSrc || $[2] !== onVisible || $[3] !== pageIndex || $[4] !== zoom) {
        t2 = ()=>{
            onVisible(pageIndex);
            getPageSrc(pageIndex, zoom).then(setImageSrc);
        };
        $[1] = getPageSrc;
        $[2] = onVisible;
        $[3] = pageIndex;
        $[4] = zoom;
        $[5] = t2;
    } else t2 = $[5];
    const { observedRef: observedRef, isVisibleRef: isVisibleRef } = (0, $d3d42c4a5207b051$export$a7395f9832c00176)(t1, t2);
    const [dimensions, setDimensions] = (0, $cozmU.useState)();
    let t3;
    if ($[6] !== content || $[7] !== onLoad) {
        t3 = (event)=>{
            const image = event.currentTarget;
            onLoad?.();
            if (!content) {
                const zoom_0 = image.dataset.zoom ? Number(image.dataset.zoom) : 1;
                const imageZoom = zoom_0;
                const contentWidth = image.naturalWidth / imageZoom;
                const contentHeight = image.naturalHeight / imageZoom;
                setDimensions({
                    width: contentWidth,
                    height: contentHeight
                });
            }
        };
        $[6] = content;
        $[7] = onLoad;
        $[8] = t3;
    } else t3 = $[8];
    const onImageLoad = (0, $eMuR8.useStaticCallback)(t3);
    let t4;
    let t5;
    if ($[9] !== getPageSrc || $[10] !== isVisibleRef || $[11] !== pageIndex || $[12] !== zoom) {
        t4 = ()=>{
            if (isVisibleRef.current) getPageSrc(pageIndex, zoom).then(setImageSrc);
        };
        t5 = [
            isVisibleRef,
            pageIndex,
            zoom,
            getPageSrc
        ];
        $[9] = getPageSrc;
        $[10] = isVisibleRef;
        $[11] = pageIndex;
        $[12] = zoom;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = content ?? dimensions ?? defaultDimensions;
    let t7;
    if ($[15] !== appendUpTo || $[16] !== content || $[17] !== fonts || $[18] !== imageSrc || $[19] !== observedRef || $[20] !== onImageLoad || $[21] !== pageIndex || $[22] !== t6 || $[23] !== zoom) {
        t7 = /*#__PURE__*/ $cozmU.createElement($54be4644f67ec168$var$PageView, {
            ref: observedRef,
            dimensions: t6,
            imageSrc: imageSrc,
            content: content,
            fonts: fonts,
            pageIndex: pageIndex,
            zoom: zoom,
            onImageLoad: onImageLoad,
            appendUpTo: appendUpTo
        });
        $[15] = appendUpTo;
        $[16] = content;
        $[17] = fonts;
        $[18] = imageSrc;
        $[19] = observedRef;
        $[20] = onImageLoad;
        $[21] = pageIndex;
        $[22] = t6;
        $[23] = zoom;
        $[24] = t7;
    } else t7 = $[24];
    return t7;
} : ({ getPageSrc: getPageSrc, content: content, fonts: fonts, pageIndex: pageIndex, zoom: zoom, defaultDimensions: defaultDimensions, onVisible: onVisible, onLoad: onLoad, appendUpTo: appendUpTo })=>{
    const [imageSrc, setImageSrc] = (0, $cozmU.useState)();
    const { observedRef: observedRef, isVisibleRef: isVisibleRef } = (0, $d3d42c4a5207b051$export$a7395f9832c00176)({
        root: (0, $edfdd7b66687d308$export$6492b66915332185)(),
        // this will load the page 3 pages before or after the current page
        // ensuring that the page is loaded before the user scrolls to it
        rootMargin: '300%',
        threshold: 0.1
    }, ()=>{
        onVisible(pageIndex);
        getPageSrc(pageIndex, zoom).then(setImageSrc);
    });
    const [dimensions, setDimensions] = (0, $cozmU.useState)();
    const onImageLoad = (0, $eMuR8.useStaticCallback)((event)=>{
        const image = event.currentTarget;
        onLoad?.();
        if (!content) {
            const zoom_0 = image.dataset.zoom ? Number(image.dataset.zoom) : 1;
            const imageZoom = zoom_0;
            const contentWidth = image.naturalWidth / imageZoom;
            const contentHeight = image.naturalHeight / imageZoom;
            setDimensions({
                width: contentWidth,
                height: contentHeight
            });
        }
    });
    (0, $cozmU.useEffect)(()=>{
        if (isVisibleRef.current) getPageSrc(pageIndex, zoom).then(setImageSrc);
    }, [
        isVisibleRef,
        pageIndex,
        zoom,
        getPageSrc
    ]);
    return /*#__PURE__*/ $cozmU.createElement($54be4644f67ec168$var$PageView, {
        ref: observedRef,
        dimensions: content ?? dimensions ?? defaultDimensions,
        imageSrc: imageSrc,
        content: content,
        fonts: fonts,
        pageIndex: pageIndex,
        zoom: zoom,
        onImageLoad: onImageLoad,
        appendUpTo: appendUpTo
    });
};








function $30f79f8edeb8ccf9$export$22d539f9bf78e8a3(getContent, paginationSize) {
    const [contentRanges, setContentRanges] = (0, $cozmU.useState)([]);
    const contentRangesRequestRef = (0, $cozmU.useRef)({});
    const loadPageContent = (0, $eMuR8.useStaticCallback)(async (pageInd)=>{
        var _contentRangesRequestRef_current, _contentRangeInd;
        const contentRangeInd = Math.floor(pageInd / paginationSize);
        // Content already loaded for this page range
        if (contentRanges[contentRangeInd]) return;
        const startIndex = contentRangeInd * paginationSize;
        const endIndex = startIndex + paginationSize;
        (_contentRangesRequestRef_current = contentRangesRequestRef.current)[_contentRangeInd = contentRangeInd] ?? (_contentRangesRequestRef_current[_contentRangeInd] = getContent(startIndex, endIndex));
        const content = await contentRangesRequestRef.current[contentRangeInd];
        setContentRanges((prev)=>{
            const newRanges = [
                ...prev
            ];
            newRanges[contentRangeInd] = content;
            return newRanges;
        });
    });
    function getPageContent(pageInd_0) {
        const contentRangeInd_0 = Math.floor(pageInd_0 / paginationSize);
        const page = contentRanges[contentRangeInd_0]?.pages[pageInd_0 % paginationSize];
        const fonts = contentRanges[contentRangeInd_0]?.fonts;
        return {
            page: page,
            fonts: fonts
        };
    }
    const documentMetadata = (0, $cozmU.useMemo)(()=>({
            defaultDimensions: contentRanges[0]?.pages[0] ? {
                height: contentRanges[0].pages[0].height,
                width: contentRanges[0].pages[0].width
            } : undefined,
            pageCount: contentRanges[0]?.total_pages ?? 4
        }), [
        contentRanges
    ]);
    return {
        getPageContent: getPageContent,
        loadPageContent: loadPageContent,
        documentMetadata: documentMetadata
    };
}








const $1ce38210b13fff70$export$31d37ff78a483ce2 = ()=>{
    const element = (0, $1hQ0e.getDocument)();
    return element && element.getElementById((0, $glkQ6.DOCUMENT_SCROLL_ROOT_ID));
};








const $d62a9c858caebb9e$export$56b96ab7f5c89562 = (getPageImageUrl)=>{
    const imageUrlRefs = (0, $cozmU.useRef)({});
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const url of Object.values(imageUrlRefs.current))URL.revokeObjectURL(url);
        };
    }, []);
    const getImageUrl = (0, $eMuR8.useStaticCallback)(async (pageNumber, zoom)=>{
        const key = `${pageNumber}-${zoom}`;
        if (imageUrlRefs.current[key]) return imageUrlRefs.current[key];
        let url = await getPageImageUrl(pageNumber, zoom);
        const isBlobUrl = url.startsWith('blob:');
        if (!isBlobUrl) {
            const blob = await fetch(url).then((res)=>res.blob());
            url = URL.createObjectURL(blob);
        }
        imageUrlRefs.current[key] = url;
        return url;
    });
    return getImageUrl;
};


const $fe45a459a017d285$var$documentViewerStyles = null;
const $fe45a459a017d285$var$DEFAULT_PAGINATION_SIZE = 50;
const $fe45a459a017d285$var$INITIAL_PAGE_COUNT = 50;
const $fe45a459a017d285$var$APPEND_STEP = 50; /**
                         * TAIL-APPEND PATTERN FOR LAZY LOADING:
                         *
                         * The <Page> component has an `onVisible: () => void` prop that is called when the page
                         * enters the viewport (via useIntersectionObserver with a 300% rootMargin). This callback
                         * is currently used to load page content via `loadPageContent(i)`.
                         *
                         * For the LazyAppendPages feature (T2.3), the parent component can leverage this same
                         * mechanism by:
                         * 1. Rendering only a subset of pages (lazyPageCount instead of all documentMetadata.pageCount)
                         * 2. Passing onVisible={handleAppend} ONLY to the last rendered page (i === lazyPageCount - 1)
                         * 3. For all other pages, passing onVisible={() => loadPageContent(i)} as usual
                         *
                         * When the last page enters the viewport, handleAppend will be triggered, which can:
                         * - Fetch the next batch of pages
                         * - Append them to the rendered page list
                         * - This effectively creates a tail-append/infinite-scroll behavior without any changes to <Page>
                         *
                         * No changes to the <Page> signature are required. The onVisible callback is already
                         * properly wired and can be overridden by parent components for different behaviors.
                         */ 
const $fe45a459a017d285$var$LegacyPages = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { documentMetadata: documentMetadata, getPageContent: getPageContent, loadPageContent: loadPageContent, getImageUrl: getImageUrl, zoom: zoom, onSuccess: onSuccess, style: style, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2mHwu88HPE _4bt5LAIZbP _2WAcuGIZbP _313842GXk2 _4ouGXIN91d _3iDTPbQ4SZ _0aFT5vbt8w _39xV02W9qI"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== documentMetadata.pageCount) {
        t2 = [
            ...Array(documentMetadata.pageCount ?? 4)
        ];
        $[1] = documentMetadata.pageCount;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== documentMetadata.defaultDimensions || $[4] !== getImageUrl || $[5] !== getPageContent || $[6] !== loadPageContent || $[7] !== onSuccess || $[8] !== t2 || $[9] !== zoom) {
        t3 = t2.map((_, i)=>{
            const { page: page, fonts: fonts } = getPageContent(i);
            return /*#__PURE__*/ $cozmU.createElement((0, $54be4644f67ec168$export$6955bcca4cd3539f), {
                key: i,
                getPageSrc: getImageUrl,
                pageIndex: i,
                zoom: zoom,
                defaultDimensions: documentMetadata.defaultDimensions,
                onVisible: loadPageContent,
                onLoad: i === 0 ? onSuccess : undefined,
                fonts: fonts,
                content: page
            });
        });
        $[3] = documentMetadata.defaultDimensions;
        $[4] = getImageUrl;
        $[5] = getPageContent;
        $[6] = loadPageContent;
        $[7] = onSuccess;
        $[8] = t2;
        $[9] = zoom;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== onTouchEnd || $[12] !== onTouchMove || $[13] !== onTouchStart || $[14] !== style || $[15] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "document-viewer",
            style: style,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            className: t1
        }, t3);
        $[11] = onTouchEnd;
        $[12] = onTouchMove;
        $[13] = onTouchStart;
        $[14] = style;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ documentMetadata: documentMetadata, getPageContent: getPageContent, loadPageContent: loadPageContent, getImageUrl: getImageUrl, zoom: zoom, onSuccess: onSuccess, style: style, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "document-viewer",
        style: style,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        className: (0, $hekY6.default)([
            "_2mHwu88HPE _4bt5LAIZbP _2WAcuGIZbP _313842GXk2 _4ouGXIN91d _3iDTPbQ4SZ _0aFT5vbt8w _39xV02W9qI"
        ])
    }, [
        ...Array(documentMetadata.pageCount ?? 4)
    ].map((_, i)=>{
        const { page: page, fonts: fonts } = getPageContent(i);
        return /*#__PURE__*/ $cozmU.createElement((0, $54be4644f67ec168$export$6955bcca4cd3539f), {
            key: i,
            getPageSrc: getImageUrl,
            pageIndex: i,
            zoom: zoom,
            defaultDimensions: documentMetadata.defaultDimensions,
            onVisible: loadPageContent,
            onLoad: i === 0 ? onSuccess : undefined,
            fonts: fonts,
            content: page
        });
    }));
};
const $fe45a459a017d285$var$LazyAppendPages = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { documentMetadata: documentMetadata, getPageContent: getPageContent, loadPageContent: loadPageContent, getImageUrl: getImageUrl, zoom: zoom, onSuccess: onSuccess, style: style, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd } = t0;
    const totalPages = documentMetadata.pageCount ?? 4;
    let t1;
    if ($[0] !== totalPages) {
        t1 = ()=>Math.min($fe45a459a017d285$var$INITIAL_PAGE_COUNT, totalPages);
        $[0] = totalPages;
        $[1] = t1;
    } else t1 = $[1];
    const [lazyPageCount, setLazyPageCount] = (0, $cozmU.useState)(t1);
    const lastAppendTriggerIndex = (0, $cozmU.useRef)(-1);
    const totalPagesRef = (0, $cozmU.useRef)(totalPages);
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const total = totalPagesRef.current;
            const hash = window.location.hash;
            const match = hash.match(/^#page-(\d+)$/);
            if (match) {
                const targetPage = parseInt(match[1], 10);
                if (targetPage >= 1 && targetPage <= total) {
                    lastAppendTriggerIndex.current = targetPage - 1;
                    setLazyPageCount((prev)=>Math.max(prev, targetPage));
                    requestAnimationFrame(()=>{
                        const el = (0, $1hQ0e.getDocument)()?.getElementById(`page-${targetPage}`);
                        if (el) el.scrollIntoView();
                    });
                }
            }
        };
        t3 = [];
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] !== loadPageContent || $[5] !== totalPages) {
        t4 = (pageIndex)=>{
            if (pageIndex > lastAppendTriggerIndex.current) {
                lastAppendTriggerIndex.current = pageIndex;
                setLazyPageCount((c)=>Math.min(c + $fe45a459a017d285$var$APPEND_STEP, totalPages));
            }
            loadPageContent(pageIndex);
        };
        $[4] = loadPageContent;
        $[5] = totalPages;
        $[6] = t4;
    } else t4 = $[6];
    const handleAppendAndLoadPageContent = t4;
    let t5;
    if ($[7] !== totalPages) {
        t5 = (targetPage_0)=>{
            const clamped = Math.min(Math.max(targetPage_0, 0), totalPages);
            if (clamped > lastAppendTriggerIndex.current) {
                lastAppendTriggerIndex.current = clamped - 1;
                setLazyPageCount((prev_0)=>Math.max(prev_0, clamped));
            }
        };
        $[7] = totalPages;
        $[8] = t5;
    } else t5 = $[8];
    const appendUpTo = t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_2mHwu88HPE _4bt5LAIZbP _2WAcuGIZbP _313842GXk2 _4ouGXIN91d _3iDTPbQ4SZ _0aFT5vbt8w _39xV02W9qI"
        ]);
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== lazyPageCount) {
        t7 = [
            ...Array(lazyPageCount)
        ];
        $[10] = lazyPageCount;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== appendUpTo || $[13] !== documentMetadata.defaultDimensions || $[14] !== getImageUrl || $[15] !== getPageContent || $[16] !== handleAppendAndLoadPageContent || $[17] !== lazyPageCount || $[18] !== loadPageContent || $[19] !== onSuccess || $[20] !== t7 || $[21] !== zoom) {
        t8 = t7.map((_, i)=>{
            const { page: page, fonts: fonts } = getPageContent(i);
            return /*#__PURE__*/ $cozmU.createElement((0, $54be4644f67ec168$export$6955bcca4cd3539f), {
                key: i,
                getPageSrc: getImageUrl,
                pageIndex: i,
                zoom: zoom,
                defaultDimensions: documentMetadata.defaultDimensions,
                onVisible: i === lazyPageCount - 1 ? handleAppendAndLoadPageContent : loadPageContent,
                onLoad: i === 0 ? onSuccess : undefined,
                fonts: fonts,
                content: page,
                appendUpTo: appendUpTo
            });
        });
        $[12] = appendUpTo;
        $[13] = documentMetadata.defaultDimensions;
        $[14] = getImageUrl;
        $[15] = getPageContent;
        $[16] = handleAppendAndLoadPageContent;
        $[17] = lazyPageCount;
        $[18] = loadPageContent;
        $[19] = onSuccess;
        $[20] = t7;
        $[21] = zoom;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== onTouchEnd || $[24] !== onTouchMove || $[25] !== onTouchStart || $[26] !== style || $[27] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "document-viewer",
            style: style,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            className: t6
        }, t8);
        $[23] = onTouchEnd;
        $[24] = onTouchMove;
        $[25] = onTouchStart;
        $[26] = style;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    return t9;
} : ({ documentMetadata: documentMetadata, getPageContent: getPageContent, loadPageContent: loadPageContent, getImageUrl: getImageUrl, zoom: zoom, onSuccess: onSuccess, style: style, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd })=>{
    const totalPages = documentMetadata.pageCount ?? 4;
    const [lazyPageCount, setLazyPageCount] = (0, $cozmU.useState)(()=>Math.min($fe45a459a017d285$var$INITIAL_PAGE_COUNT, totalPages)); // lastAppendTriggerIndex deduplicates: only append when a strictly-larger
    // tail page fires onVisible. This prevents double-append on scroll-up-then-down.
    const lastAppendTriggerIndex = (0, $cozmU.useRef)(-1); // Handle #page-N URL hash on first load: fast-forward lazyPageCount to include the target page.
    // Capture totalPages in a ref so the one-shot effect can read it without being re-run when
    // totalPages changes (the effect must only fire once, on mount).
    const totalPagesRef = (0, $cozmU.useRef)(totalPages);
    (0, $cozmU.useEffect)(()=>{
        const total = totalPagesRef.current;
        const hash = window.location.hash;
        const match = hash.match(/^#page-(\d+)$/);
        if (match) {
            const targetPage = parseInt(match[1], 10);
            if (targetPage >= 1 && targetPage <= total) {
                // Update dedup ref BEFORE setLazyPageCount so handleAppend does not
                // cascade when the new tail page enters the viewport via IntersectionObserver.
                lastAppendTriggerIndex.current = targetPage - 1; // Fast-forward lazyPageCount to include the target page
                setLazyPageCount((prev)=>Math.max(prev, targetPage)); // After the pages are mounted (next animation frame), scroll to the target
                requestAnimationFrame(()=>{
                    const el = (0, $1hQ0e.getDocument)()?.getElementById(`page-${targetPage}`);
                    if (el) el.scrollIntoView();
                });
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps -- intentionally one-shot; totalPages read via ref
    const handleAppendAndLoadPageContent = (0, $cozmU.useCallback)((pageIndex)=>{
        if (pageIndex > lastAppendTriggerIndex.current) {
            lastAppendTriggerIndex.current = pageIndex;
            setLazyPageCount((c)=>Math.min(c + $fe45a459a017d285$var$APPEND_STEP, totalPages));
        }
        loadPageContent(pageIndex);
    }, [
        totalPages,
        loadPageContent
    ]);
    const appendUpTo = (0, $cozmU.useCallback)((targetPage_0)=>{
        const clamped = Math.min(Math.max(targetPage_0, 0), totalPages);
        if (clamped > lastAppendTriggerIndex.current) {
            lastAppendTriggerIndex.current = clamped - 1;
            setLazyPageCount((prev_0)=>Math.max(prev_0, clamped));
        }
    }, [
        totalPages
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "document-viewer",
        style: style,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        className: (0, $hekY6.default)([
            "_2mHwu88HPE _4bt5LAIZbP _2WAcuGIZbP _313842GXk2 _4ouGXIN91d _3iDTPbQ4SZ _0aFT5vbt8w _39xV02W9qI"
        ])
    }, [
        ...Array(lazyPageCount)
    ].map((_, i)=>{
        const { page: page, fonts: fonts } = getPageContent(i);
        return /*#__PURE__*/ $cozmU.createElement((0, $54be4644f67ec168$export$6955bcca4cd3539f), {
            key: i,
            getPageSrc: getImageUrl,
            pageIndex: i,
            zoom: zoom,
            defaultDimensions: documentMetadata.defaultDimensions,
            onVisible: i === lazyPageCount - 1 ? handleAppendAndLoadPageContent : loadPageContent,
            onLoad: i === 0 ? onSuccess : undefined,
            fonts: fonts,
            content: page,
            appendUpTo: appendUpTo
        });
    }));
};
const $fe45a459a017d285$export$c749023b2d124212 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { onSuccess: onSuccess, getContent: getContent, getPageImageUrl: getPageImageUrl, paginationSize: t1, zoom: zoom, enableLazyPageRendering: t2 } = t0;
    const paginationSize = t1 === undefined ? $fe45a459a017d285$var$DEFAULT_PAGINATION_SIZE : t1;
    const enableLazyPageRendering = t2 === undefined ? false : t2;
    const { getPageContent: getPageContent, loadPageContent: loadPageContent, documentMetadata: documentMetadata } = (0, $30f79f8edeb8ccf9$export$22d539f9bf78e8a3)(getContent, paginationSize);
    const getImageUrl = (0, $d62a9c858caebb9e$export$56b96ab7f5c89562)(getPageImageUrl);
    let t3;
    if ($[0] !== zoom) {
        t3 = {
            "--document-viewer-zoom": zoom
        };
        $[0] = zoom;
        $[1] = t3;
    } else t3 = $[1];
    const style = t3;
    const previousZoomRef = (0, $cozmU.useRef)(zoom);
    let t4;
    let t5;
    if ($[2] !== zoom) {
        t4 = ()=>{
            const previousZoom = previousZoomRef.current;
            if (previousZoom !== zoom) {
                const container = (0, $1ce38210b13fff70$export$31d37ff78a483ce2)();
                if (!container) return;
                const viewportCenterX = container.scrollLeft + container.clientWidth / 2;
                const viewportCenterY = container.scrollTop + container.clientHeight / 2;
                const scaleDiff = zoom / previousZoom - 1;
                container.scrollLeft = container.scrollLeft + viewportCenterX * scaleDiff;
                container.scrollTop = container.scrollTop + viewportCenterY * scaleDiff;
                previousZoomRef.current = zoom;
            }
        };
        t5 = [
            zoom
        ];
        $[2] = zoom;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t4, t5);
    const touchStartRef = (0, $cozmU.useRef)(null);
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (event)=>{
            const touch = event.touches[0];
            if (touch) touchStartRef.current = {
                x: touch.clientX,
                y: touch.clientY
            };
        };
        $[5] = t6;
    } else t6 = $[5];
    const onTouchStart = t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (event_0)=>{
            const container_0 = (0, $1ce38210b13fff70$export$31d37ff78a483ce2)();
            if (!container_0 || !touchStartRef.current) return;
            const touch_0 = event_0.touches[0];
            if (!touch_0) return;
            const deltaX = touchStartRef.current.x - touch_0.clientX;
            const deltaY = touchStartRef.current.y - touch_0.clientY;
            container_0.scrollLeft = container_0.scrollLeft + deltaX;
            container_0.scrollTop = container_0.scrollTop + deltaY;
            touchStartRef.current = {
                x: touch_0.clientX,
                y: touch_0.clientY
            };
        };
        $[6] = t7;
    } else t7 = $[6];
    const onTouchMove = (0, $eMuR8.useStaticCallback)(t7);
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            touchStartRef.current = null;
        };
        $[7] = t8;
    } else t8 = $[7];
    const onTouchEnd = t8;
    let t9;
    if ($[8] !== documentMetadata || $[9] !== getImageUrl || $[10] !== getPageContent || $[11] !== loadPageContent || $[12] !== onSuccess || $[13] !== onTouchMove || $[14] !== style || $[15] !== zoom) {
        t9 = {
            documentMetadata: documentMetadata,
            getPageContent: getPageContent,
            loadPageContent: loadPageContent,
            getImageUrl: getImageUrl,
            zoom: zoom,
            onSuccess: onSuccess,
            style: style,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        };
        $[8] = documentMetadata;
        $[9] = getImageUrl;
        $[10] = getPageContent;
        $[11] = loadPageContent;
        $[12] = onSuccess;
        $[13] = onTouchMove;
        $[14] = style;
        $[15] = zoom;
        $[16] = t9;
    } else t9 = $[16];
    const sharedProps = t9;
    let t10;
    if ($[17] !== enableLazyPageRendering || $[18] !== sharedProps) {
        t10 = enableLazyPageRendering ? /*#__PURE__*/ $cozmU.createElement($fe45a459a017d285$var$LazyAppendPages, sharedProps) : /*#__PURE__*/ $cozmU.createElement($fe45a459a017d285$var$LegacyPages, sharedProps);
        $[17] = enableLazyPageRendering;
        $[18] = sharedProps;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
} : ({ onSuccess: onSuccess, getContent: getContent, getPageImageUrl: getPageImageUrl, paginationSize: paginationSize = $fe45a459a017d285$var$DEFAULT_PAGINATION_SIZE, zoom: zoom, enableLazyPageRendering: enableLazyPageRendering = false })=>{
    const { getPageContent: getPageContent, loadPageContent: loadPageContent, documentMetadata: documentMetadata } = (0, $30f79f8edeb8ccf9$export$22d539f9bf78e8a3)(getContent, paginationSize);
    const getImageUrl = (0, $d62a9c858caebb9e$export$56b96ab7f5c89562)(getPageImageUrl);
    const style = {
        '--document-viewer-zoom': zoom
    };
    const previousZoomRef = (0, $cozmU.useRef)(zoom); // Apply zoom with center-based adjustment
    (0, $cozmU.useLayoutEffect)(()=>{
        const previousZoom = previousZoomRef.current; // Only adjust scroll if zoom actually changed
        if (previousZoom !== zoom) {
            // If we are not using a custom scroll element, we don't need to adjust the scroll position
            const container = (0, $1ce38210b13fff70$export$31d37ff78a483ce2)();
            if (!container) return;
             // Calculate the center point of the viewport before zoom
            const viewportCenterX = container.scrollLeft + container.clientWidth / 2;
            const viewportCenterY = container.scrollTop + container.clientHeight / 2; // Calculate scale difference
            const scaleDiff = zoom / previousZoom - 1; // Adjust scroll to keep center point fixed
            container.scrollLeft += viewportCenterX * scaleDiff;
            container.scrollTop += viewportCenterY * scaleDiff; // Update previous zoom
            previousZoomRef.current = zoom;
        }
    }, [
        zoom
    ]);
    const touchStartRef = (0, $cozmU.useRef)(null);
    const onTouchStart = (0, $cozmU.useCallback)((event)=>{
        const touch = event.touches[0];
        if (touch) touchStartRef.current = {
            x: touch.clientX,
            y: touch.clientY
        };
    }, []);
    const onTouchMove = (0, $eMuR8.useStaticCallback)((event_0)=>{
        const container_0 = (0, $1ce38210b13fff70$export$31d37ff78a483ce2)();
        if (!container_0 || !touchStartRef.current) return;
        const touch_0 = event_0.touches[0];
        if (!touch_0) return;
         // Calculate the delta from the last touch position
        const deltaX = touchStartRef.current.x - touch_0.clientX;
        const deltaY = touchStartRef.current.y - touch_0.clientY; // Apply the scroll
        container_0.scrollLeft += deltaX;
        container_0.scrollTop += deltaY; // Update the reference position for the next move
        touchStartRef.current = {
            x: touch_0.clientX,
            y: touch_0.clientY
        };
    });
    const onTouchEnd = (0, $cozmU.useCallback)(()=>{
        touchStartRef.current = null;
    }, []);
    const sharedProps = {
        documentMetadata: documentMetadata,
        getPageContent: getPageContent,
        loadPageContent: loadPageContent,
        getImageUrl: getImageUrl,
        zoom: zoom,
        onSuccess: onSuccess,
        style: style,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
    return enableLazyPageRendering ? /*#__PURE__*/ $cozmU.createElement($fe45a459a017d285$var$LazyAppendPages, sharedProps) : /*#__PURE__*/ $cozmU.createElement($fe45a459a017d285$var$LegacyPages, sharedProps);
};
module.exports["DocumentViewer"] = $fe45a459a017d285$export$c749023b2d124212;

});

parcelRegister("glkQ6", function(module, exports) {
const $7fb6f782fcb38932$export$dfbf4c31558011d1 = 'document-scroll-root';
module.exports["DOCUMENT_SCROLL_ROOT_ID"] = $7fb6f782fcb38932$export$dfbf4c31558011d1;

});


//# sourceMappingURL=doc.bd1bab68.js.map
